'use client';

import { Box } from '@mui/material';
import { SimpleSearch } from '@/shared/ui/search/SimpleSearch';
import { plannerSimpleSearchConfig } from '@/entities/planner';
import type { SimpleSearchQuery } from '@/shared/ui/search/SimpleSearch/types/search.types';

interface PlannerTableSearchProps {
  onSearch: (query: SimpleSearchQuery) => void;
  initialQuery?: SimpleSearchQuery;
}

/**
 * 플래너 테이블 검색 영역 (SimpleSearch만 사용)
 */
export function PlannerTableSearch({ onSearch, initialQuery }: PlannerTableSearchProps) {
  return (
    <Box sx={{ mb: 2 }}>
      <SimpleSearch
        config={plannerSimpleSearchConfig}
        onSearch={onSearch}
        initialQuery={initialQuery}
      />
    </Box>
  );
}
